import { FC } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Checkbox, ListItem, ListItemText } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import styled from '@emotion/styled';

const Handle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-right: 4px;
  color: rgba(0, 0, 0, 0.45);
  cursor: grab;
  touch-action: none;

  &:active {
    cursor: grabbing;
  }
`;

interface Props {
  id: string;
  label: string;
  checked: boolean;
  onToggle: () => void;
}

export const ColumnPickerRow: FC<Props> = ({ id, label, checked, onToggle }) => {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({ id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    background: isDragging ? 'rgba(0,0,0,0.04)' : undefined,
  };

  return (
    <ListItem ref={setNodeRef} style={style} dense disableGutters sx={{ pl: 1, pr: 2 }}>
      <Handle ref={setActivatorNodeRef} {...attributes} {...listeners} aria-label="drag handle">
        <DragIndicatorIcon fontSize="small" />
      </Handle>
      <Checkbox edge="start" checked={checked} onChange={onToggle} tabIndex={-1} disableRipple />
      <ListItemText primary={label} slotProps={{ primary: { noWrap: true } }} />
    </ListItem>
  );
};
